export function jsonColorConvertor(jsonColor, customOpacity){
  // check the input is json or not
  if(jsonColor && typeof jsonColor === 'string') {
    const parsedColor = JSON.parse(jsonColor)
    return `rgba(${parsedColor.r}, ${parsedColor.g}, ${parsedColor.b}, ${customOpacity || parsedColor.a})`
  }
  throw Error("can't parse the color. this is not a json!")
}